import { render, staticRenderFns } from "./aiConfiguration.vue?vue&type=template&id=6d4a7d85&"
import script from "./aiConfiguration.vue?vue&type=script&lang=js&"
export * from "./aiConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports